/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { DeprecatedSelect } from "@octopusdeploy/design-system-octopus-components";
import type { ServerTimezoneResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { ExpandableFormSection, Note } from "~/components/form";
import timezoneSummary from "~/components/timezoneSummary";
interface ScheduleTimezoneProps {
    timezones: ServerTimezoneResource[];
    timezone: string;
    onTimezoneChanged(timezone: string): void;
}
export default class ScheduleTimezone extends React.Component<ScheduleTimezoneProps> {
    render() {
        return (<div>
                <ExpandableFormSection errorKey="ScheduleTimezones" title="Schedule Timezone" summary={timezoneSummary(this.props.timezones, this.props.timezone)} help="Select the timezone used for the schedule.">
                    <DeprecatedSelect value={this.props.timezone} allowClear={true} onChange={(timezone) => this.props.onTimezoneChanged(timezone!)} items={this.props.timezones.map((pg) => ({ value: pg.Id, text: pg.Name }))} label="Select timezone"/>
                    <Note>Timezones are shown with UTC offsets for the standard time. Schedule run times will be calculated using this timezone and will be adjusted for daylight saving time when applicable.</Note>
                </ExpandableFormSection>
            </div>);
    }
    static displayName = "ScheduleTimezone";
}
